:host {
  display: block;
  width: var(--cms-container-width);
  margin-top: var(--cms-spacing-300);
  margin-bottom: var(--cms-components-mb);
  @include cms-base-font-100;
  --cms-theme-text-color: var(--cms-semanticColors-base-inverted-strong-text);
  --cms-theme-border-color: var(--cms-semanticColors-transparency-inverted-strong-border);
  --cms-theme-svg-color: var(--cms-semanticColors-base-inverted-strong-icon);

}

.contact-cta {
  width: var(--cms-container-width);
}

.container {
  @include cms-default-grid-container;
  justify-items: center;
  position: relative;
  color: var(--cms-theme-text-color);
  padding-bottom: var(--cms-spacing-200);
}

.container>* {
  grid-area: var(--cms-default-grid-area);
}

figcaption {
  font-style: italic;
  padding-top: var(--cms-spacing-050);
}

.logo-container {
  padding: var(--cms-spacing-050);
  background: var(--cms-semanticColors-base-strong-background);
  position: relative;
  top: -1.875rem;

  .logo {
    display: block;
    margin: auto;
  }
}

.text-container {
  --cms-default-grid-area: auto / auto / auto / span 12;

  .intro-container {
    text-align: center;

    .intro-text {
      margin: 0 0 var(--cms-spacing-075);

      & a {
        color: var(--cms-theme-text-color);
      }
    }
  }
}

.contact-data-container {
  height: auto;
  padding: var(--cms-spacing-100);
  border: var(--cms-border-size-xs) solid var(--cms-theme-border-color);

  .contact-data-headline-wrapper {
    text-align: center;
    padding-bottom: 1rem;

    .contact-data-headline {
      margin: 0;
      @include headline-font-150;
    }
  }

  .contact-data-table {
    --cms-grid-gap: var(--cms-spacing-075);
    --cms-default-grid-area: auto / auto / auto / span 12;
    --cms-grid-padding: 0;
    display: grid;
    grid-area: var(--cms-default-grid-area);
    gap: var(--cms-grid-gap);

    .row {
      @include cms-default-grid-container;
      max-width: 100%;
      margin: 0;
    }
  }
}

.contact-data-cell {
  --cms-grid-gap: var(--cms-spacing-050);
  --cms-default-grid-area: auto / auto / auto / span 12;
  grid-area: var(--cms-default-grid-area);
  padding: var(--cms-spacing-100);
  align-items: center;
  gap: var(--cms-grid-gap);
  display: flex;
  justify-content: center;
  background: var(--cms-semanticColors-transparency-medium-background);
  font-family: var(--cms-brandfont2);
}

.content {
  border-bottom: var(--cms-spacing-012) solid var(--cms-theme-border-color);
}

.link {
  color: var(--cms-theme-text-color);
  text-decoration: none;

  &:hover {
    border-bottom: var(--cms-border-size-0125) solid var(--cms-semanticColors-transparency-strong-background);
  }

  &:active {
    color: var(--cms-semanticColors-base-inverted-strong-active-text);
  }
}

.group-picture-container {
  --cms-default-grid-area: auto / 2 / auto / span 10;
  width: 100%;
  height: fit-content;
  margin: 0;
}

.contacts {
  --cms-default-grid-area: auto / auto / auto / span 12;
  --cms-grid-padding: 0;
  width: var(--cms-container-width);
  @include cms-default-grid-container;
}

.contact-container {
  grid-area: var(--cms-default-grid-area);
  display: flex;
  flex-direction: column;
  width: var(--cms-container-width);
}

.contact-image-container {
  width: var(--cms-container-width);
  margin: 0 0 var(--cms-spacing-100);

  img {
    width: var(--cms-container-width);
  }
}

.contact-info-container {
  padding-top: var(--cms-spacing-050);
}

.contact-list {
  list-style: none outside none;
  padding-left: 0;
}

li {
  --cms-grid-gap: var(--cms-spacing-050);
  display: flex;
  flex-direction: row;
  gap: var(--cms-grid-gap);
  padding-bottom: var(--cms-spacing-100);
}

.content {
  border-bottom: var(--cms-spacing-012) solid var(--cms-theme-border-color);
  font-family: var(--cms-brandfont2);
}

.link {
  color: var(--cms-theme-text-color);
  text-decoration: none;

  &:hover {
    border-bottom: 2px solid var(--cms-semanticColors-transparency-strong-background);
  }

  &:active {
    color: var(--cms-semanticColors-base-inverted-strong-active-text);
  }
}

.button-wrapper {
  width: var(--cms-container-width);
}

@include media-width($breakpoint-sm) {

  .button-wrapper {
    --cms-default-grid-area: auto / 4 / auto / span 6;
  }

  .quote-container {
    --cms-default-grid-area: auto / 2 / auto / span 10;
  }

  .contacts {
    --cms-default-grid-area: auto / 2 / auto / span 10;
  }

  .group-picture-container {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }

  .text-container {
    --cms-default-grid-area: auto / 2 / auto / span 10;
  }

  .contact-data-cell {
    --cms-default-grid-area: auto / auto / auto / span 6;
  }

  .row {
    .contact-data-cell:first-child:last-child {
      /* Just one item */
      --cms-default-grid-area: auto / auto / auto / span 12;
    }

    &:first-child {

      /* first row */
      .contact-data-cell {
        --cms-default-grid-area: auto / auto / auto / span 4;
      }

      // span 6 if only two items in first row
      .contact-data-cell:nth-child(2):last-child,
      .contact-data-cell:nth-last-child(2):first-child {
        --cms-default-grid-area: auto / auto / auto / span 6;
      }

    }
  }

  .contacts .contact-container {
    --cms-default-grid-area: auto / auto / auto / span 6;
  }

  .contacts .contact-container.once {
    --cms-default-grid-area: auto / 5 / auto / span 4;
  }

  :host {
    margin-top: var(--cms-spacing-400);
  }
}

@include media-width($breakpoint-md) {
  .contacts {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }

  .quote-container {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }

  .group-picture-container {
    --cms-default-grid-area: auto / 4 / auto / span 6;
  }

  .text-container {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }

  .contacts .contact-container {
    --cms-default-grid-area: auto / auto / auto / span 4;
  }

  .contacts .contact-container.once {
    --cms-default-grid-area: auto / 5 / auto / span 4;
  }

  .contacts .contact-container.twice {
    --cms-default-grid-area: auto / 3 / auto / span 4;
  }
}